import type { OapStatus } from '@/logic/oapAttainment';

// Witems' designed text-on-tint pairs (--wi-text-primary-<family> on --wi-background-<family>),
// never a --wi-status-* fill as text. Report-only and advisory rows are not verdicts, so they wear
// the neutral surface.
type Family = 'good' | 'info' | 'bad' | 'moderate' | null;
const FAMILY: Record<OapStatus, Family> = {
  met: 'good',
  improving: 'info',
  not_met: 'bad',
  stale: 'moderate',
  insufficient: 'moderate',
  no_reading: 'moderate',
  report_only: null,
  advisory: null,
};

export default function GoalStatusTag({ status, label }: { status: OapStatus; label: string }) {
  const fam = FAMILY[status];
  const style = fam
    ? { background: `var(--wi-background-${fam})`, color: `var(--wi-text-primary-${fam})` }
    : { background: 'var(--wi-background-tertiary)', color: 'var(--wi-text-secondary)' };
  return <span className="oap-pill" data-status={status} style={style}>{label}</span>;
}
